module.exports = __webpack_public_path__ + "static/media/straightface.f5e8963e.svg";